import sections from './sections'

export default {
  name: 'setting-widgets-guide',
  data () {
    return {
      sections,
      panel: 0
    }
  },
  computed: {
    isMobile () {
      return this.$vuetify.breakpoint.width < 960
    }
  },
  mounted () {
    const hash = this.$route.hash ? this.$route.hash.replace('#', '') : ''
    if (hash && sections.some(section => section.id === hash)) {
      this.$nextTick(() => this.scrollToSection(hash))
    }
  },
  methods: {
    goBack () {
      this.$router.push({ name: 'setting.widgets' })
    },
    scrollToSection (id) {
      const target = this.$refs[id]
      const el = Array.isArray(target) ? target[0] : target
      if (el) {
        this.$vuetify.goTo(el, { duration: 300, offset: 12 })
      }
    },
    demoStyle (block) {
      return {
        background: block.bg,
        color: block.color
      }
    },
    btnStyle (block) {
      return {
        background: block.btnBg,
        color: block.btnColor
      }
    }
  }
}
